import DataPanel from "../DataPanel";
import { useCallback, useEffect, useState } from "react";
import BonnellSpringDetails from "./BonnellSpringDetails";
import { formatCurrency } from "../../engine/PriceUtilities";
import useSpringMaterialCustomerPriceApi, { convertSpringPricesToMaterialIdIndexedArray, SpringMaterialCustomerPrice } from "../../api/SpringMaterialCustomerPriceApi";
import { getPricedSpringFormattedMaterialNames, getPricedSpringFormattedMaterialsThickness, PricedSpring } from "../../api/PricedSpringApi";
import useHttp from "../../security/Http.hook";

interface Properties {
  readonly customerId: number;
  readonly priceListId: number;
}

const columns = [
  {
    name: 'name',
    label: 'Nazwa',
    options: {}
  },
  {
    name: 'materialName',
    label: 'Materiał',
    options: {}
  },
  {
    name: 'materialThickness',
    label: 'Grubość drutu',
    options: {}
  },
  {
    name: 'width',
    label: 'Szerokość',
    options: {}
  },
  {
    name: 'length',
    label: 'Długość',
    options: {}
  },
  {
    name: 'price',
    label: 'Cena [zł]',
    options: {}
  }
];

const BonnellSpringsPanel = (properties: Properties) => {
  const http = useHttp();
  const springMaterialCustomerPriceApi = useSpringMaterialCustomerPriceApi();
  const customerId = properties.customerId;
  const priceListId = properties.priceListId;
  const [materialPrices, setMaterialPrices] = useState<SpringMaterialCustomerPrice[]>();

  const convertBonnellSprings = useCallback((pricedBonnellSpring: PricedSpring) => {
    const price = pricedBonnellSpring.price;
    return {
       id: pricedBonnellSpring.id,
       name: pricedBonnellSpring.name,
       materialName: getPricedSpringFormattedMaterialNames(pricedBonnellSpring),
       materialThickness: getPricedSpringFormattedMaterialsThickness(pricedBonnellSpring),
       width: pricedBonnellSpring.width,
       length: pricedBonnellSpring.length,
       price: price === undefined ? '?' : formatCurrency(price)
    }
  }, [customerId, priceListId, materialPrices]);

  useEffect(() => {
    springMaterialCustomerPriceApi
      .fetchSpringMaterialCustomerPrices(customerId, priceListId)
      .then(convertSpringPricesToMaterialIdIndexedArray)
      .then(setMaterialPrices);
  }, [customerId, priceListId]);

  return <>
    <DataPanel
      title='Sprężyny bonnell'
      resource={ `customers/${customerId}/price-lists/${priceListId}/bonnell-springs` }
      columns={ columns }
      deleteRequiresConfirmation
      selectableRows='multiple'
      tableSearchEnabled
      renderDetails={(detailsProps) => <BonnellSpringDetails { ...{
        ...detailsProps,
        customerId,
        priceListId,
        materialPrices: materialPrices || []
      }} />}
      convert={ convertBonnellSprings }
      onDelete={ resourceId => http.delete(`/api/customers/${customerId}/bonnell-springs/${resourceId}`) }
    />
  </>
};
export default BonnellSpringsPanel;